import { getLocale } from "../runtime";

const sv_notifybuttoncompletedlabel = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Prenumeration registrerad`
};

const notifybuttoncompletedlabel = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_notifybuttoncompletedlabel(inputs)
	return "notifyButtonCompletedLabel";
};

export { notifybuttoncompletedlabel as "notifyButtonCompletedLabel" };